export class RefreshTokenError extends Error {
    readonly contextId: string;
    constructor(contextId: string) {
      super('Refresh token deleted or fake');
      this.name = 'RefreshTokenError';
      this.contextId = contextId;
    }
  }
  